module.exports = __webpack_public_path__ + "img/slider.d7ce162e.svg";